// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TLM Kit
 *
 * Copyright © 2007-present SOHO Systems and Networks. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

:root {
  /*
   * Typography
   * ======================================================================== */

  /*
   * Layout
   * ======================================================================== */

  /*
   * Media queries breakpoints
   * ======================================================================== */  /* Extra small screen / phone */  /* Small screen / tablet */  /* Medium screen / desktop */ /* Large screen / wide desktop */
}

/* @font-face for Oswald is declared globally in /styles/custom.css with
   font-display: optional + size-adjust to prevent CLS on font swap. */

.MXc0W {
  margin: 0 auto;
  max-width: 100%;
}

.eYuYQ,
.AK7Ay,
.JrGIC,
.UZ8_I,
.YyzM8,
._kxEU,
.DM5WX,
.I8vZH {
  margin-top: 20px;
}

.feNdW {
  position: fixed;
  top: 55px;
  left: 0;
  right: 0;
  width: 60% !important;
  margin: 10px auto;
  z-index: 990;
}

.fFYrV {
  margin-top: 10px;
  margin-bottom: 10px;
}

.pDzFF {
  border-bottom: 1px solid #6ca7d1;
}

.XWgMu {
  line-height: 17px !important;
  padding: 10px 0 0 10px;
}

._3t4hf {
  font-size: 0.8em;
}

.pGza6 {
  font-size: 1em;
  color: #1a73b5;
  font-weight: 700;
}

.elKoc {
  margin-left: auto;
  margin-right: auto;
  font-family: 'Roboto', sans-serif;
  padding: 10px;
  word-break: break-word;
}

.StYYs {
  display: inline-block;
  width: 20%;
  padding: 10px;
  text-align: center;
}

/* Overriding pop up ads box for small mobile */

@media (max-width: 400px) {
  .StYYs {
    width: 50%;
    padding: 10px;
  }
}

.Cre4u {
  width: 100%;
  height: auto;
}

.vHooo {
  font-family: Dosis, sans-serif;
  height: 40px !important;
}

.elKoc p {
  margin-bottom: 0 !important;
  line-height: 17px !important;
  font-size: 0.9em;
  color: #222;
}

.xSn4z,
.ib9pU,
.S1BWL {
  display: inline-block;
  vertical-align: top;
}

.ib9pU {
  padding-top: 10px;
}

/* For smartphone */

@media (max-width: 900px) {
  .xSn4z {
    width: 100%;
  }

  .h47ii {
    display: none;
  }

  .xSn4z .DM5WX {
    display: none;
  }

  .ib9pU {
    width: 100%;
    padding-top: 15%;
  }

  .S1BWL {
    width: 100%;
  }

  .PVbxm {
    display: block;
  }

  .HmXRW {
    display: block;
  }

  .pDzFF {
    border-bottom: none;
    border-top: 1px solid #eae8e8;
  }

  .JrGIC {
    padding-left: 10px;
    padding-right: 10px;
  }

  .eYuYQ,
  .AK7Ay,
  .UZ8_I,
  .YyzM8,
  ._kxEU,
  .I8vZH,
  .n9yUr {
    padding-left: 10px;
    padding-right: 10px;
  }

  /* Only apply for the top ads fix section, not the one in middle of middle section */
  .ib9pU > .feNdW {
    position: fixed;
    top: 55px;
    left: 0;
    right: 0;
    width: 100% !important;
    margin: 0 auto;
    z-index: 990;
  }
}

/* For tablet */

@media (min-width: 900px) and (max-width: 1200px) {
  .xSn4z {
    width: 100%;
  }

  .xSn4z .DM5WX {
    display: none;
  }

  .PBWPL {
    display: none;
  }

  .ib9pU {
    width: 70%;
    padding-left: 10px;
  }

  .S1BWL {
    width: 30%;
    padding-left: 15px;
  }

  .PVbxm {
    display: table-cell;
    width: 20%;
    vertical-align: top;
  }

  .HmXRW {
    display: table-cell;
    width: 80%;
    vertical-align: top;
  }

  .pDzFF {
    padding-top: 180px;
  }

  .feNdW {
    position: fixed;
    top: 55px;
    left: 0;
    right: 0;
    width: 100% !important;
    margin: 0 auto;
    z-index: 990;
  }
}

/* For PC */

@media (min-width: 1200px) {
  .xSn4z {
    width: 20%;
    padding-right: 15px;
  }

  .PBWPL {
    display: none;
  }

  .ib9pU {
    width: 60%;
    padding-right: 50px;
    padding-left: 50px;
    padding-top: 10%;
  }

  .feNdW {
    position: fixed;
    top: 55px;
    left: 0;
    right: 0;
    width: 60% !important;
    margin: 0 auto;
    z-index: 990;
    padding-left: 50px;
    padding-right: 50px;
  }

  .S1BWL {
    width: 20%;
    padding-left: 15px;
  }

  .DM5WX {
    padding-left: 20px;
  }

  .S1BWL .DM5WX {
    display: none;
  }

  .PVbxm {
    display: block;
  }

  .HmXRW {
    display: block;
  }

  .pDzFF {
    border-bottom: none;
    margin-top: 20px;
  }
}

.G2hMR {
  font-family: Oswald, sans-serif;
  display: block;
  font-size: 22px;
  text-transform: uppercase;
  color: #1a72b5;
  margin-bottom: 10px;
}

.AK7Ay {
  margin-top: 10px;
}

.DM5WX {
  padding-left: 10px;
}

.UJlcz {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  height: auto;
}

.L1_JX {
  text-align: center;
}

.I8vZH {
  text-align: center;
}

.ZGksY {
  background-color: #1a73b5 !important;
  color: white !important;
  text-decoration: none;
}

.mjZnb {
  display: inline-block;
  margin-right: 20px;
}

.WS6QD {
  font-family: Oswald, sans-serif;
  font-size: 1.2em;
  color: #1a73b5;
  font-weight: 500;
  text-decoration: underline;
  padding-left: 3px;
  padding-right: 3px;
  background-color: white;
}

.WS6QD:hover {
  background-color: #1a73b5;
  color: white;
}

.zGpxG {
  margin-top: -10px;
}

.c20EK {
  display: block;
  border-bottom: 1px solid #9bcbec;
  color: #0074c2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.c20EK:hover {
  color: white;
  background-color: #0074c2;
  padding-left: 5px;
}

.nSeuy {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.tabJg {
  color: white;
  display: inline-block;
  margin-left: 10px;
  margin-bottom: 5px;
  padding: 4px 5px;
  font-size: 0.9em;
  background-color: #0074c2;
  line-height: 15px;
  cursor: pointer;
  border-radius: 2px;
}

.tabJg:hover {
  text-decoration: underline;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MXc0W`,
	"adsSection": `eYuYQ`,
	"eventSection": `AK7Ay`,
	"latestNewsSection": `JrGIC`,
	"otherNewsSection": `UZ8_I`,
	"oldNewsSection": `YyzM8`,
	"archiveSection": `_kxEU`,
	"latestIssueSection": `DM5WX`,
	"categoryButtonsSection": `I8vZH`,
	"adsFixSection": `feNdW`,
	"adsInlineSection": `fFYrV`,
	"pubDetailOuterContainer": `pDzFF`,
	"personelContainer": `XWgMu`,
	"personPosition": `_3t4hf`,
	"personName": `pGza6`,
	"publicationWriteUp": `elKoc`,
	"issueCard": `StYYs`,
	"issueCardImg": `Cre4u`,
	"issueTitle": `vHooo`,
	"leftSection": `xSn4z`,
	"middleSection": `ib9pU`,
	"rightSection": `S1BWL`,
	"leftSectionTop": `h47ii`,
	"pubDetailContainer": `PVbxm`,
	"publicationWriteUpContainer": `HmXRW`,
	"industrialLinkSection": `n9yUr`,
	"leftSectionBottom": `PBWPL`,
	"sectionTitle": `G2hMR`,
	"latestIssueCardImg": `UJlcz`,
	"latestIssueContentWrapper": `L1_JX`,
	"currentChosen": `ZGksY`,
	"categoryButtonWrapper": `mjZnb`,
	"categoryButton": `WS6QD`,
	"newSquareListContainer": `zGpxG`,
	"oldNewsLink": `c20EK`,
	"noItemOfCatAnnounce": `nSeuy`,
	"mediaKitLink": `tabJg`
};
module.exports = ___CSS_LOADER_EXPORT___;
